import React from 'react';
import { GiftIcon } from './icons/GiftIcon';
const bonuses = [{
  title: 'Experta en Hydra Lips™',
  value: '$27 USD'
}, {
  title: 'Colorimetría en Labios™',
  value: '$21 USD'
}, {
  title: 'Guía de Cuidados Post + Mensajes Listos',
  value: '$19 USD'
}, {
  title: 'Lip Blush Workbook™',
  value: '$24 USD'
}, {
  title: 'Master en BB Glow™',
  value: '$29 USD'
}, {
  title: 'Ficha Clínica + Consentimiento Profesional',
  value: '$14 USD'
}, {
  title: 'Kit de Contenido para BB Lips™',
  value: '$29 USD'
}];
export function Bonuses() {
  return <section id="bonos" className="py-12 px-4 bg-white" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-10 space-y-3" data-id="element-3">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-[#E5A5A0]/10 rounded-xl mb-2 text-[#E5A5A0]" data-id="element-4">
            <GiftIcon className="w-6 h-6" data-id="element-5" />
          </div>
          <h2 className="text-2xl md:text-3xl font-semibold text-[#3D3028]" data-id="element-6">
            SOLO HOY: 7 BONOS EXCLUSIVOS GRATIS
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8" data-id="element-7">
          {bonuses.map((bonus, index) => <div key={index} className="bg-[#FAF8F4] p-6 rounded-xl border border-[#D4C4B0]/20 relative" data-id="element-8">
              <div className="absolute top-3 right-3 bg-[#E5A5A0] text-white text-[10px] font-semibold px-2.5 py-1 rounded-full" data-id="element-9">
                BONO {index + 1}
              </div>
              <h3 className="font-semibold text-[#3D3028] text-sm mb-2 pr-14 leading-tight" data-id="element-10">
                {bonus.title}
              </h3>
              <p className="text-[#E5A5A0] font-medium text-xs" data-id="element-11">
                Valor {bonus.value}
              </p>
            </div>)}
        </div>

        <div className="bg-[#3D3028] text-[#FAF8F4] p-6 rounded-xl text-center max-w-2xl mx-auto" data-id="element-12">
          <p className="text-lg md:text-xl" data-id="element-13">
            Valor total de los bonos:{' '}
            <span className="line-through opacity-50" data-id="element-14">$197 USD</span>
            <span className="block mt-2 text-[#E5A5A0] font-semibold text-xl" data-id="element-15">
              HOY: GRATIS
            </span>
          </p>
        </div>
      </div>
    </section>;
}